import { characters } from "../data/characters";
import scss from "./Squad.module.scss";

export const Squad = ({ squad }) => {
  return (
    <section className={scss.squad}>
      {squad.map((c) => (
        <div key={c} className={scss.imgWrapper}>
          <img alt={characters[c].name} src={characters[c].icon} />
        </div>
      ))}
    </section>
  );
};
